/**
 * Application routes configuration
 * Centralized route definitions for navigation
 */
export const ROUTES = {
  AUTH: {
    LOGIN: '/login',
    REGISTER: '/register',
    RESET: '/reset',
    PASSWORD: '/password',
    PASSWORD_MIGRATION: '/password?migration=true',
  },
  DASHBOARD: {
    ROOT: '/dashboard',
  },
  SYSTEM: {
    UNDER_REVISION: '/under-revision',
  },
} as const;

export type AuthRoutes = (typeof ROUTES.AUTH)[keyof typeof ROUTES.AUTH];
export type DashboardRoutes =
  (typeof ROUTES.DASHBOARD)[keyof typeof ROUTES.DASHBOARD];
export type SystemRoutes = (typeof ROUTES.SYSTEM)[keyof typeof ROUTES.SYSTEM];
export type AllRoutes = AuthRoutes | DashboardRoutes | SystemRoutes;
